import { useTexture } from "@react-three/drei";
import * as THREE from "three";

export interface CharacterImageProps {
  imagePath: string;
  onComplete?: (data?: unknown) => void; // Added onComplete prop
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: [number, number, number] | number;
}

/**
 * Visual Novel용 2D 캐릭터 이미지 컴포넌트
 * PlaneGeometry에 텍스처를 입혀 3D 공간에 배치합니다.
 */
export function CharacterImage({
  imagePath,
  onComplete, // Added onComplete prop
  position = [0, 0, 0],
  rotation = [0, 0, 0], // 기본 회전
  scale = 1,
}: CharacterImageProps) {
  const texture = useTexture(imagePath, (tex) => {
    // Call onComplete when texture is loaded
    if (onComplete) {
      onComplete(tex);
    }
  });

  // 텍스처 종횡비 계산 (이미지가 찌그러지지 않도록)
  const img = texture.image as HTMLImageElement; // Cast texture.image to HTMLImageElement
  const aspect = img ? img.width / img.height : 1;
  const finalScale: [number, number, number] = Array.isArray(scale)
    ? [scale[0] * aspect, scale[1], scale[2]]
    : [scale * aspect * 3, scale * 3, 1]; // 기본 높이를 3 정도로 설정

  return (
    <mesh position={position} rotation={rotation} scale={finalScale}>
      <planeGeometry args={[1, 1]} />
      <meshBasicMaterial
        map={texture}
        transparent={true}
        side={THREE.DoubleSide}
        alphaTest={0.5} // 투명도 처리를 위해 alphaTest 추가
      />
    </mesh>
  );
}
